import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import * as yup from "yup";

export interface ICardDataFormMeta {
    cardProgram: FormInputMeta;
    panGeneration: FormInputMeta;
    pan: FormInputMeta;
    effectiveDate: FormInputMeta;
    expirationDate: FormInputMeta;
    primary_secondary: FormInputMeta;
    primaryCard: FormInputMeta;
    customizationFees: FormInputMeta;
    membershipFees: FormInputMeta;
    newCardDesign: FormInputMeta;
    fastDelivery: FormInputMeta;

}

const cardDataFormMeta = {} as ICardDataFormMeta;

cardDataFormMeta.cardProgram = {
    name: "cardProgram",
    type: "select",
    label: "Programme Carte",
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
};

cardDataFormMeta.panGeneration = {
    name: "panGeneration",
    type: "radio",
    options: [
        {
            label: "Automatique",
            value: "automatic",
        },
        {
            label: "Manuel",
            value: "manual",
        },
    ],
    validation: yup.string().required("Champ obligatoire !")
};

cardDataFormMeta.pan = {
    name: "pan",
    type: "text",
    label: "PAN",
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
};

cardDataFormMeta.effectiveDate = {
    name: "effectiveDate",
    type: "date",
    label: "Date Effective",
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
};

cardDataFormMeta.expirationDate = {
    name: "expirationDate",
    type: "date",
    label: "Date Expi.",
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
};

cardDataFormMeta.primary_secondary = {
    name: "primary_secondary",
    type: "radio",
    options: [
        {
            label: "Primaire",
            value: "primary",
        },
        {
            label: "Secondaire",
            value: "secondary",
        },
    ],
    validation: yup.string().required("Champ obligatoire !")
};

cardDataFormMeta.primaryCard = {
    name: "primaryCard",
    type: "select",
    label: "Carte Primaire",
    placeholder: "",
    validation: yup.string()
};

cardDataFormMeta.customizationFees = {
    name: "customizationFees",
    type: "select",
    label: "Frais Personnalisation",
    placeholder: "",
    validation: yup.string()
};

cardDataFormMeta.membershipFees = {
    name: "membershipFees",
    type: "select",
    label: "Frais Adhésion",
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !"),
};

cardDataFormMeta.newCardDesign = {
    name: "newCardDesign",
    type: "checkbox",
    label: "Design nouvelle Carte",
    placeholder: "",
    validation: yup.boolean()
};

cardDataFormMeta.fastDelivery = {
    name: "fastDelivery",
    type: "checkbox",
    label: "Livraison Rapide",
    placeholder: "",
    validation: yup.boolean()
};


export default cardDataFormMeta;